export default "__VITE_ASSET__DoyDDJBq__"